import React from "react";

export default function Textarea({
  className,
  id,
  maxLength,
  autoFocus,
  value,
  onChange,
  onPressEnter,
}) {
  return (
    <textarea
      className={className}
      id={id}
      maxLength={maxLength}
      autoFocus={autoFocus}
      value={value}
      onChange={(event) => {
        onChange && onChange(event);
      }}
      onKeyPress={(event) => {
        if (event.code === "Enter") {
          event.preventDefault();
          onPressEnter && onPressEnter();
        }
      }}
    />
  );
}
